import { Vector2 } from 'three';
/**
 * Creates Tiles (dimensions, positions) from the given factory and tile-dimensions
 */
export class TileGridBuilder {
    constructor(_imageTypeConfigurationFactory, _tileSize) {
        this._imageTypeConfigurationFactory = _imageTypeConfigurationFactory;
        this._tileSize = _tileSize;
    }
    build(imageData) {
        const tileGridConfiguration = this._createTileGridConfiguration(imageData);
        return this._createTileGrid(tileGridConfiguration, imageData);
    }
    _getImageStride(imageType) {
        return this._imageTypeConfigurationFactory.createForType(imageType).stride;
    }
    _createTileGridConfiguration(imageData) {
        const tileGridConfiguration = { rowCount: 1, columnCount: 1 };
        tileGridConfiguration.columnCount = Math.ceil(imageData.Width / this._tileSize.width);
        tileGridConfiguration.rowCount = Math.ceil(imageData.Height / this._tileSize.height);
        return tileGridConfiguration;
    }
    _createTileGrid(tileGridConfiguration, imageData) {
        const { rowCount, columnCount } = tileGridConfiguration;
        const imageRawData = this._createImageRawData(imageData);
        const tileGrid = new Array(rowCount * columnCount);
        for (let rowIt = 0; rowIt < rowCount; rowIt++) {
            for (let columnIt = 0; columnIt < columnCount; columnIt++) {
                const startX = columnIt * this._tileSize.width;
                let endX = startX + this._tileSize.width;
                if (endX > imageData.Width) {
                    endX = imageData.Width;
                }
                const startY = rowIt * this._tileSize.height;
                let endY = startY + this._tileSize.height;
                if (endY > imageData.Height) {
                    endY = imageData.Height;
                }
                const gridPosition = new Vector2(columnIt, rowIt);
                const position = new Vector2(startX, startY);
                const dimension = { width: endX - startX, height: endY - startY };
                const data = this._createTileRawData(imageRawData, position, dimension, imageData);
                const tileData = { data, position, dimension, gridPosition };
                const index = rowIt * columnCount + columnIt;
                tileGrid[index] = tileData;
            }
        }
        return tileGrid;
    }
    _createImageRawData(imageData) {
        const { buffer, byteOffset, byteLength } = imageData.Pixels.data;
        return new Uint8Array(buffer, byteOffset, byteLength);
    }
    _createTileRawData(imageRawData, position, dimension, imageData) {
        const stride = this._getImageStride(imageData.ImageType);
        const startX = position.x;
        const startY = position.y;
        const endY = startY + dimension.height;
        /*
         * optimization for images where width is <= than tile size:
         *   `Uint8Array::subarray` method takes order of magnitude less time than
         *   `Uint8Array::set` method
         */
        if (startX === 0 && dimension.width === imageData.Width) {
            const resultStart = startY * dimension.width * stride;
            const resultEnd = endY * dimension.width * stride;
            return imageRawData.subarray(resultStart, resultEnd);
        }
        const result = new Uint8Array(dimension.width * dimension.height * stride);
        for (let yIt = startY; yIt < endY; yIt++) {
            const subStart = yIt * imageData.Width * stride + startX * stride;
            const subEnd = subStart + (dimension.width * stride);
            const subArray = imageRawData.subarray(subStart, subEnd);
            const resultOffset = (yIt - startY) * dimension.width * stride;
            result.set(subArray, resultOffset);
        }
        return result;
    }
}
//# sourceMappingURL=TileGridBuilder.js.map